export default __webpack_public_path__ + "static/media/Communication2.cd5ec463.svg";